import { useState } from "react";
import Styleclasses from "../Basic-info/style.module.css";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { showSuccessNotification } from "Utils/Notifications";
import { showWarningAlert } from "Utils/Alerts";
import { get_Rental_Income, add_Rental_Income } from "Services/Requests";
import { useEffect } from "react";
import { useStore } from "Store";
import DatePicker from "react-date-picker";

import Load from "Components/Loader/loader";
interface Inputs {
    building_value: string;
    land_value: number;
    address_of_property: string;
    date_of_property_purchased: Date | null;
    property_holder: string;
    income: string;
    rents_received: string;
    royalties_received: string;
    expenses: string;
    mortgage_interest: string;
    other_interest: string;
    insurance: string;
    repairs: string;
    auto_and_travel: string;
    advertising: string;
    taxes: string;
    legal_and_other_professional_taxes: string;
    cleaning_and_maintenance: string;
    commissions: string;
    utilities: string;
    management_fees: string;
    supplies: string;
    other_expenses: string;
    no_of_days_rented_during_year: string;
}
function PersonalInfo() {
    const { isDisabled } = useStore((state: any) => state);
    const [isChecked, setIschecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        setValue,

        control,
        reset,
        formState: { errors },
    } = useForm<Inputs>();
    const formData = watch();
    function convertDateToUserTimezone(givenDate: Date): Date {
        const userTimezoneOffset = new Date().getTimezoneOffset() / 60;

        // Remove timezone offset from given date
        const utcDate = new Date(
            givenDate.toLocaleString("en-US", { timeZone: "UTC" })
        );

        // Add user's timezone offset to utcDate
        const userDate = new Date(utcDate);
        userDate.setHours(userDate.getHours() + userTimezoneOffset);

        return userDate;
    }
    const GetDetails = async () => {
        setLoading(true);
        try {
            const response = await get_Rental_Income();
            setTimeout(() => {
                setLoading(false);
            }, 300);
            if (response.data.status == 1) {
                reset({
                    ...response?.data?.rental_income,
                    date_of_property_purchased:
                        response?.data?.rental_income
                            ?.date_of_property_purchased &&
                        response?.data?.rental_income
                            ?.date_of_property_purchased != "0000-00-00" &&
                        convertDateToUserTimezone(
                            response?.data?.rental_income
                                ?.date_of_property_purchased
                        ),
                });
            } else {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team"
                );
                setLoading(false);
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        GetDetails();
    }, []);
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        if (!isChecked) {
            return;
        }
        setLoading(true);

        try {
            const response = await add_Rental_Income({
                ...data,
                date_of_property_purchased: moment(
                    data?.date_of_property_purchased
                )?.format("YYYY-MM-DD"),
            });
            setLoading(false);
            if (response.data.Status === 1) {
                showSuccessNotification("Personal info updated successfully");
            } else {
                showWarningAlert(
                    response?.data.Message || "Somethign went wrong try again"
                );
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    return (
        <div
            className={`${Styleclasses["Container"]} ${Styleclasses["rental"]}`}>
            {loading && <Load />}
            <form action="" onSubmit={handleSubmit(onSubmit)}>
                <div className={Styleclasses["info"]}>
                    <h3>Rental Income</h3>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Building Value</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            className={
                                errors?.building_value &&
                                Styleclasses["error-input"]
                            }
                            {...register("building_value", { required: false })}
                        />
                        {errors?.building_value && <p>This is required </p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Land Value</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="Land Value"
                            {...register("land_value", { required: false })}
                        />
                        {errors?.land_value && <p>This is required </p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Address of the property</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            className={
                                errors?.address_of_property &&
                                Styleclasses["error-input"]
                            }
                            placeholder="Address of the property"
                            {...register("address_of_property", {
                                required: false,
                            })}
                        />
                        {errors?.address_of_property && <p>this is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">
                            Number of days rented during the year
                        </label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            className={
                                errors?.no_of_days_rented_during_year &&
                                Styleclasses["error-input"]
                            }
                            placeholder="Enter Number"
                            {...register("no_of_days_rented_during_year", {
                                required: false,
                            })}
                        />
                        {errors?.no_of_days_rented_during_year && (
                            <p>This is required</p>
                        )}
                    </div>
                    <div className={Styleclasses["form-date"]}>
                        <label htmlFor="">Date of property Purchased</label>
                        <Controller
                            disabled={isDisabled}
                            control={control}
                            name="date_of_property_purchased"
                            render={({ field }) => (
                                <DatePicker
                                    className={
                                        Styleclasses["date-picker-custom"]
                                    }
                                    onKeyDown={(e) => e.preventDefault()}
                                    yearPlaceholder="YYYY"
                                    monthPlaceholder="MM"
                                    dayPlaceholder="DD"
                                    disabled={field.disabled}
                                    {...field}
                                    format="MM/dd/yyyy"
                                    calendarIcon={<span>📅</span>}
                                    clearIcon={false}
                                />
                            )}
                        />

                        {errors?.date_of_property_purchased && (
                            <p>This is required</p>
                        )}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Property Holder</label>
                        <Controller
                            name="property_holder"
                            control={control}
                            disabled={isDisabled}
                            // disabled={disabled}
                            rules={{
                                required: "This is required",
                            }}
                            render={({ field }) => (
                                <input
                                    {...field}
                                    className={
                                        errors?.property_holder &&
                                        Styleclasses["error-input"]
                                    }
                                    type="text" // Use type="text" to better control the value
                                    placeholder="Property Holder"
                                    onInput={(e) => {
                                        // Cast the event target to HTMLInputElement to access value
                                        const input =
                                            e.target as HTMLInputElement;
                                        input.value = input.value.replace(
                                            /[^A-Za-z]/g, // Replace non-alphabetic characters
                                            ""
                                        );
                                    }}
                                />
                            )}
                        />
                        {/*  <input
                            disabled={isDisabled}
                            type="text"
                            {...register("property_holder", {
                                required: false,
                            })}
                            className={
                                errors?.property_holder &&
                                Styleclasses["error-input"]
                            }
                            placeholder="Enter your SSN"
                        /> */}
                        {errors?.property_holder && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Income</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("income", {
                                required: false,
                            })}
                            className={
                                errors?.income && Styleclasses["error-input"]
                            }
                        />

                        {errors?.income && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Rents Received</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("rents_received", {
                                required: false,
                            })}
                            className={
                                errors?.rents_received &&
                                Styleclasses["error-input"]
                            }
                        />

                        {errors?.rents_received && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Royalties Received</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            {...register("royalties_received", {
                                required: false,
                            })}
                            className={
                                errors?.royalties_received &&
                                Styleclasses["error-input"]
                            }
                        />

                        {errors?.royalties_received && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Expenses</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("expenses", {
                                required: false,
                            })}
                            className={
                                errors?.expenses && Styleclasses["error-input"]
                            }
                        />

                        {errors?.expenses && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Other Interest</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("other_interest", {
                                required: false,
                            })}
                            className={
                                errors?.other_interest &&
                                Styleclasses["error-input"]
                            }
                        />

                        {errors?.other_interest && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Mortgage Interest</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("mortgage_interest", {
                                required: false,
                            })}
                            className={
                                errors?.mortgage_interest &&
                                Styleclasses["error-input"]
                            }
                        />
                        {errors?.mortgage_interest && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Insurance</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("insurance", {
                                required: false,
                            })}
                            className={
                                errors?.insurance && Styleclasses["error-input"]
                            }
                        />
                        {errors?.insurance && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Repairs</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("repairs", {
                                required: false,
                            })}
                            className={
                                errors?.repairs && Styleclasses["error-input"]
                            }
                        />
                        {errors?.repairs && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Auto & travels</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("auto_and_travel", {
                                required: false,
                            })}
                            className={
                                errors?.auto_and_travel &&
                                Styleclasses["error-input"]
                            }
                        />
                        {errors?.auto_and_travel && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Advertising</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("advertising", {
                                required: false,
                            })}
                            className={
                                errors?.advertising &&
                                Styleclasses["error-input"]
                            }
                        />
                        {errors?.advertising && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Taxes</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("taxes", {
                                required: false,
                            })}
                            className={
                                errors?.taxes && Styleclasses["error-input"]
                            }
                        />
                        {errors?.taxes && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">
                            Legal & Other Professional Fees
                        </label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("legal_and_other_professional_taxes", {
                                required: false,
                            })}
                            className={
                                errors?.legal_and_other_professional_taxes &&
                                Styleclasses["error-input"]
                            }
                        />
                        {errors?.legal_and_other_professional_taxes && (
                            <p>This is required</p>
                        )}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Cleaning & Maintenance </label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("cleaning_and_maintenance", {
                                required: false,
                            })}
                            className={
                                errors?.cleaning_and_maintenance &&
                                Styleclasses["error-input"]
                            }
                        />
                        {errors?.cleaning_and_maintenance && (
                            <p>This is required</p>
                        )}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Commissions </label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("commissions", {
                                required: false,
                            })}
                            className={
                                errors?.commissions &&
                                Styleclasses["error-input"]
                            }
                        />

                        {errors?.commissions && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Utilities </label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("utilities", {
                                required: false,
                            })}
                            className={
                                errors?.utilities && Styleclasses["error-input"]
                            }
                        />
                        {errors?.utilities && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Management Fees </label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("management_fees", {
                                required: false,
                            })}
                            className={
                                errors?.management_fees &&
                                Styleclasses["error-input"]
                            }
                        />
                        {errors?.management_fees && <p>This is required</p>}
                    </div>
                    <div className={Styleclasses["form-control"]}>
                        <label htmlFor="">Other Expenses </label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="US$"
                            {...register("other_expenses", {
                                required: false,
                            })}
                            className={
                                errors?.other_expenses &&
                                Styleclasses["error-input"]
                            }
                        />
                        {errors?.other_expenses && <p>This is required</p>}
                    </div>
                    <div
                        className={Styleclasses["declaration"]}
                        style={{ gridColumn: "1/-1" }}>
                        <h3>
                            <input
                                disabled={isDisabled}
                                type="checkbox"
                                id="pushNotification"
                                onChange={(e) => setIschecked(e.target.checked)}
                            />
                            <label
                                htmlFor="pushNotification"
                                className={Styleclasses["checkbox-label"]}>
                                I declare that the information in this
                                application is true and correct{" "}
                            </label>
                        </h3>
                        <div className={Styleclasses["save-btns"]}>
                            <button disabled={isDisabled || !isChecked}>
                                Save
                            </button>
                            {/* <button type="button">Reset</button> */}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default PersonalInfo;
